// Programmes — contenu inspiré du site ECL France, adapté au Campus Abidjan
// Toutes les pages sous /formations/* utilisent cette donnée

const COMMON_PERKS = [
  { stat: "7", label: "Campus à l'étranger", desc: "Étudier à l'international dans un de nos campus partenaires." },
  { stat: "80+", label: "Nationalités", desc: "Un environnement multiculturel au cœur de votre formation." },
  { stat: "24/7", label: "E-learning", desc: "Plateforme du groupe ECL accessible à tout moment." },
];

const COMMON_RYTHMES = ["Initial", "Alternance", "E-learning"];

export const PROGRAMS = {
  // ---------- BBA Parent ----------
  bba: {
    parent: true,
    eyebrow: "BBA — Bachelor of Business Administration",
    title: "Devenez",
    italic: "opérationnel.",
    tagline: "Post-bac à Bac+3 · Initial · Alternance · E-learning",
    hero_subtitle:
      "Le Bachelor of Business Administration est un diplôme international de premier cycle en administration des entreprises (Marketing Digital, Ressources Humaines, Finance et Comptabilité, Entrepreneuriat, Commerce International, Communication, Achats et Logistique).",
    image: "/assets/etudiants-campus-2.jpg",
    key_info: [
      { label: "Durée", value: "3 ans" },
      { label: "Niveau de sortie", value: "Bac+3" },
      { label: "Accès", value: "Post-bac (Général, Techno, Pro)" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "À qui s'adresse le BBA ?",
        content:
          "Le BBA est accessible aux titulaires d'un baccalauréat général, technologique ou professionnel, ainsi qu'aux étudiants issus d'une formation post-bac (classes préparatoires, BTS, BUT, Licence 1 ou 2) souhaitant intégrer un cursus en management à dimension internationale.",
      },
      {
        title: "Une formation professionnalisante",
        content:
          "Le BBA associe enseignements théoriques et expériences pratiques à travers des stages, des projets d'entreprise et des missions professionnelles. Il représente le premier cycle du Programme Grande École de l'ECL et permet une poursuite d'études vers le MBA en vue d'une diplomation Bac+5.",
      },
      {
        title: "Une spécialisation en 3ème année",
        content:
          "En 3ème année de BBA, vous choisissez une spécialisation parmi plusieurs parcours afin d'orienter votre formation vers le domaine d'expertise qui correspond à votre projet professionnel et préparer votre entrée en MBA.",
      },
    ],
    perks: COMMON_PERKS,
    years: [
      { slug: "bba/1", label: "1ère année", level: "Bac+1" },
      { slug: "bba/2", label: "2ème année", level: "Bac+2" },
      { slug: "bba/3", label: "3ème année", level: "Bac+3" },
    ],
  },

  "bba/1": {
    eyebrow: "BBA 1ère année",
    title: "BBA",
    italic: "1ère année.",
    tagline: "Post-Bac · Bac+1 · Initial · Alternance · E-learning",
    hero_subtitle:
      "Posez les fondations de votre carrière business. Une première année généraliste qui couvre les bases du management, de la communication, du marketing et des outils digitaux.",
    parent_slug: "bba",
    key_info: [
      { label: "Niveau", value: "Bac+1" },
      { label: "Durée", value: "1 an" },
      { label: "Accès", value: "Post-Bac" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "Objectifs pédagogiques",
        content:
          "Acquérir les fondamentaux du management, de la communication d'entreprise et du marketing. Développer son agilité numérique et ses soft-skills (travail d'équipe, prise de parole, organisation).",
      },
      {
        title: "Modules clés",
        content: null,
        list: [
          "Introduction au management des organisations",
          "Marketing et études de marché",
          "Comptabilité et fondamentaux financiers",
          "Communication écrite & orale",
          "Outils digitaux et bureautique avancée",
          "Anglais des affaires",
          "Culture économique et géopolitique",
          "Projet professionnel personnalisé",
        ],
      },
      {
        title: "Mise en pratique",
        content:
          "Stage de découverte de 4 à 6 semaines en entreprise (initial) ou immersion en entreprise tout au long de l'année (alternance). Projets de groupe, défis business, événements étudiants.",
      },
    ],
    perks: COMMON_PERKS,
  },

  "bba/2": {
    eyebrow: "BBA 2ème année",
    title: "BBA",
    italic: "2ème année.",
    tagline: "Bac+2 · Initial · Alternance · E-learning",
    hero_subtitle:
      "Consolidez votre socle business et développez votre expertise opérationnelle. Une année où la pratique prend le pas sur la théorie.",
    parent_slug: "bba",
    key_info: [
      { label: "Niveau", value: "Bac+2" },
      { label: "Durée", value: "1 an" },
      { label: "Accès", value: "BBA1 validé / admission parallèle Bac+1 ou Bac+2" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "Objectifs pédagogiques",
        content:
          "Maîtriser les techniques de gestion, de management et de marketing avancé. S'initier aux logiques de stratégie d'entreprise et préparer la spécialisation de 3ème année.",
      },
      {
        title: "Modules clés",
        list: [
          "Stratégie & business modèles",
          "Marketing digital & analytics",
          "Gestion financière et contrôle de gestion",
          "Droit des affaires et RH",
          "Vente et négociation B2B / B2C",
          "Anglais des affaires niveau avancé",
          "Entrepreneuriat & innovation",
          "Mission entreprise tutorée",
        ],
      },
      {
        title: "Mise en pratique",
        content:
          "Stage de 2 à 3 mois (initial) ou immersion à temps plein en entreprise (alternance). Mission tutorée sur un cas réel d'entreprise.",
      },
    ],
    perks: COMMON_PERKS,
  },

  "bba/3": {
    eyebrow: "BBA 3ème année",
    title: "BBA",
    italic: "3ème année.",
    tagline: "Bac+3 · Spécialisation · Double diplôme possible",
    hero_subtitle:
      "Choisissez la spécialisation qui correspond à vos ambitions et donnez une nouvelle dimension à votre parcours. Cette année de professionnalisation conduit à l'obtention d'un diplôme français et peut s'enrichir d'une expérience académique internationale grâce à notre campus de Lyon.",
    parent_slug: "bba",
    key_info: [
      { label: "Niveau de sortie", value: "Bac+3" },
      { label: "Durée", value: "1 an" },
      { label: "Spécialisations", value: "7 au choix" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "7 spécialisations au choix",
        content: null,
        list: [
          "Marketing Digital",
          "Ressources Humaines",
          "Finance et Comptabilité",
          "Entrepreneuriat",
          "Commerce International",
          "Communication",
          "Achats et Logistique",
        ],
      },
      {
        title: "Modules clés (tronc commun)",
        list: [
          "Management stratégique",
          "Pilotage de la performance",
          "Conduite de projet",
          "Anglais professionnel certifiant",
          "Mémoire professionnel",
          "Soft-skills & leadership",
        ],
      },
      {
        title: "Diplôme Français",
        content:
          "À l'issue de votre formation, vous obtenez un diplôme français attestant de vos compétences académiques et professionnelles. Vous avez la possibilité de poursuivre votre parcours sur le campus de Lyon.",
      },
    ],
    perks: COMMON_PERKS,
  },

  // ---------- MBA Parent ----------
  mba: {
    parent: true,
    eyebrow: "MBA — Master of Business Administration",
    title: "Vision",
    italic: "stratégique.",
    tagline: "Bac+3 à Bac+5 · Initial · Alternance · E-learning",
    hero_subtitle:
      "Le MBA forme les futurs cadres sur la gestion stratégique et les compétences managériales d'une entreprise, en tenant compte du contexte international et de la mondialisation.",
    image: "/assets/business-handshake.jpg",
    key_info: [
      { label: "Prérequis", value: "Bac+3 validé (Licence ou équivalent)" },
      { label: "Durée", value: "2 ans" },
      { label: "Niveau de sortie", value: "Bac+5" },
      { label: "Admission parallèle", value: "Possible en Bac+4" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "Une formation stratégique et internationale",
        content:
          "Le MBA combine plages théoriques en classes de 15 à 20 étudiants pour faciliter l'échange de connaissances entre intervenants professionnels et étudiants, et plages de projets pour mettre en pratique les savoir-faire acquis.",
      },
      {
        title: "Spécialisation en 2ème année",
        content: null,
        list: [
          "Marketing Digital",
          "Ressources Humaines",
          "Finance et Comptabilité",
          "Entrepreneuriat",
          "Commerce International",
          "Communication",
          "Achats et Logistique",
        ],
      },
      {
        title: "Pédagogie 70/30",
        content:
          "70% de pratique, 30% de théorie, études de cas réels ou création d'entreprise.",
      },
    ],
    perks: COMMON_PERKS,
    years: [
      { slug: "mba/1", label: "1ère année (MBA1)", level: "Bac+4" },
      { slug: "mba/2", label: "2ème année (MBA2)", level: "Bac+5" },
    ],
  },

  "mba/1": {
    eyebrow: "MBA 1ère année",
    title: "MBA",
    italic: "1ère année.",
    tagline: "Bac+4 · Initial · Alternance · E-learning",
    hero_subtitle:
      "L'année du saut managérial. Tronc commun stratégique pour préparer la spécialisation de 2ème année et le futur poste à responsabilités.",
    parent_slug: "mba",
    key_info: [
      { label: "Niveau", value: "Bac+4" },
      { label: "Durée", value: "1 an" },
      { label: "Prérequis", value: "Bac+3 validé" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "À qui s'adresse le MBA 1ère année ?",
        content:
          "Le MBA 1ère année s'adresse aux titulaires d'un Bac+3 (Licence, Bachelor ou équivalent) souhaitant accéder à des fonctions managériales et stratégiques. Il est également accessible en admission parallèle pour les professionnels justifiant d'un niveau Bac+3 validé.",
      },
      {
        title: "Objectifs pédagogiques",
        content:
          "Acquérir une vision globale du pilotage d'entreprise. Maîtriser les fondamentaux du management stratégique, de la finance d'entreprise et du leadership.",
      },
      {
        title: "Modules clés",
        list: [
          "Stratégie d'entreprise",
          "Finance et contrôle de gestion",
          "Marketing stratégique",
          "Management des équipes",
          "Conduite du changement",
          "Business international & géopolitique",
          "Anglais avancé",
          "Étude de cas en mode projet",
        ],
      },
      {
        title: "Mise en pratique",
        content:
          "Stage de 4 à 6 mois (initial) ou alternance à temps plein. Projet d'entreprise en groupe sur une problématique réelle (transformation digitale, lancement produit, plan stratégique).",
      },
    ],
    perks: COMMON_PERKS,
  },

  "mba/2": {
    eyebrow: "MBA 2ème année",
    title: "MBA",
    italic: "2ème année.",
    tagline: "Bac+5 · Spécialisation · Mémoire professionnel",
    hero_subtitle:
      "L'année de la spécialisation, vous affinez votre profil sur un domaine d'expertise et préparez votre entrée dans la vie active.",
    parent_slug: "mba",
    key_info: [
      { label: "Niveau de sortie", value: "Bac+5" },
      { label: "Durée", value: "1 an" },
      { label: "Spécialités", value: "Au choix selon parcours" },
      { label: "Rythme", value: "Initial · Alternance · E-learning" },
    ],
    sections: [
      {
        title: "7 Spécialités au choix",
        content: null,
        list: [
          "Marketing Digital",
          "Ressources Humaines",
          "Finance et Comptabilité",
          "Entrepreneuriat",
          "Commerce International",
          "Communication",
          "Achats et Logistique",
        ],
      },
      {
        title: "Modules clés (tronc commun + spécialité)",
        list: [
          "Leadership exécutif",
          "Transformation digitale",
          "Innovation disruptive",
          "Négociation complexe",
          "Mémoire professionnel ou création d'entreprise",
          "Soutenance devant un jury de professionnels",
          "Séjour international (selon parcours)",
        ],
      },
      {
        title: "Insertion professionnelle",
        content:
          "Tout au long du cursus, les étudiants développent des compétences stratégiques, managériales et opérationnelles leur permettant d'évoluer vers des fonctions à responsabilités telles que manager, chef de projet...",
      },
    ],
    perks: COMMON_PERKS,
  },

  // ---------- MBA Executive ----------
  "mba-executive": {
    eyebrow: "MBA Executive",
    title: "Pour les",
    italic: "leaders en action.",
    tagline: "11 mois · Format week-ends",
    hero_subtitle:
      "Un programme MBA conçu pour les cadres et dirigeants en activité qui veulent accélérer leur carrière sans interrompre leur trajectoire professionnelle.",
    image: "/assets/business-handshake.jpg",
    key_info: [
      { label: "Prérequis", value: "Bac+5 + 5 ans d'expérience minimum" },
      { label: "Durée", value: "11 mois" },
      { label: "Format", value: "Vendredi/samedi 1 fois/semaine + séminaires" },
      { label: "Diplôme", value: "Master Executive (Bac+5+)" },
    ],
    sections: [
      {
        title: "À qui s'adresse l'Executive MBA ?",
        content:
          "Cadres confirmés, managers, chefs d'entreprise, dirigeants en activité qui souhaitent élargir leur vision stratégique, renforcer leur leadership et accélérer leur évolution vers un poste de direction.",
      },
      {
        title: "Modules clés",
        list: [
          "Leadership exécutif & coaching individuel",
          "Stratégie d'entreprise et gouvernance",
          "Finance pour dirigeants",
          "Transformation digitale & IA appliquée au business",
          "Négociation internationale et influence",
          "Mémoire stratégique : un projet business pour votre organisation",
          "Learning expéditions (Lyon, Sénégal, Abidjan)",
        ],
      },
      {
        title: "Une promotion d'exception",
        content:
          "Les participants sont soigneusement sélectionnés, issus de secteurs variés. réseau de pairs de haut niveau, intervenants spécialisés, mentorat individuel par un dirigeant senior.",
      },
    ],
    perks: COMMON_PERKS,
  },

  // ---------- Rythmes ----------
  "rythmes": {
    eyebrow: "Rythmes de formation",
    title: "Trois rythmes,",
    italic: "un même niveau d'exigence.",
    tagline: "Initial · Alternance · E-learning",
    hero_subtitle:
      "Chaque programme de l'ECL est proposé selon un rythme adapté à votre situation personnelle et professionnelle. Quel que soit le format choisi, vous obtenez le même diplôme, bénéficiez du même niveau d'exigence académique et accédez au même réseau Alumni à l'issue de votre formation.",
    key_info: [
      { label: "Rythmes proposés", value: "3" },
      { label: "Diplôme à la sortie", value: "Identique pour tous" },
      { label: "Flexibilité", value: "Passage d'un rythme à l'autre possible" },
      { label: "Tutorat", value: "Personnalisé dans tous les rythmes" },
    ],
    sections: [
      {
        title: "Initial — Plein temps, immersion totale",
        content:
          "Opter pour le format classique, c'est choisir un enseignement en présentiel à temps plein associé à des stages obligatoires en entreprise. Vous bénéficiez ainsi d'un équilibre entre immersion académique, dynamique associative et expérience terrain, pour construire pas à pas votre réseau et votre projet professionnel.",
      },
      {
        title: "Travailler tout en étudiant dès la première année",
        content:
          "Ce cursus vous offre la possibilité d'exercer une activité professionnelle en parallèle de vos études dès la première année. Vous capitalisez ainsi jusqu'à 3 ans d'expérience significative avant l'obtention de votre diplôme.",
      },
      {
        title: "E-learning — Liberté géographique, exigence académique",
        content:
          "Ce cursus 100% en ligne, vous disposez d'une plateforme accessible 24/7. Un format spécialement conçu pour les actifs, les étudiants internationaux ou ceux qui ont des contraintes géographiques.",
      },
      {
        title: "Vous hésitez entre les formats ?",
        content: null,
        list: [
          "Format Initial : idéal si vous débutez vos études et souhaitez vivre pleinement l'expérience campus (vie associative, réseau étudiant, stages obligatoires chaque année).",
          "Format Alternance : parfait si vous voulez acquérir une expérience professionnelle tout en poursuivant vos études.",
          "Format E-learning : conçu pour ceux qui ont des contraintes géographiques ou exercent déjà une activité professionnelle, avec un accès 24/7 à la plateforme et un tutorat individualisé.",
        ],
      },
    ],
    perks: COMMON_PERKS,
  },

  // ---------- Tarifs ----------
  "tarifs": {
    eyebrow: "ECL Campus Abidjan",
    title: "Investir dans",
    italic: "votre avenir.",
    tagline: "Frais de scolarité",
    hero_subtitle:
      "À l'ECL Campus Abidjan, le financement repose sur une contribution personnelle de l'étudiant. Nous vous invitons à nous contacter pour obtenir un devis personnalisé, établi en fonction du programme et du rythme choisis.",
    key_info: [
      { label: "Devis personnalisé", value: "Sur demande" },
      { label: "Paiement échelonné", value: "Oui, jusqu'à 4 fois" },
    ],
    sections: [
      {
        title: "Structure des frais",
        content:
          "Les frais de scolarité varient en fonction du programme (BBA, MBA, Executive MBA) et du rythme choisi (Initial, Alternance, E-learning). Ils comprennent l'enseignement, l'accès aux ressources pédagogiques, à la plateforme e-learning 24/7.",
      },
      {
        title: "Solutions de financement",
        list: [
          "Paiement échelonné jusqu'à 4 mensualités sans frais",
        ],
      },
      {
        title: "Demande de devis",
        content:
          "Pour recevoir un devis personnalisé avec les frais exacts, les solutions de financement adaptées à votre profil et les bourses auxquelles vous pourriez prétendre, contactez notre service admissions via le formulaire ci-dessous ou par téléphone.",
      },
    ],
    perks: [
      { stat: "4×", label: "Échelonnement", desc: "Paiement jusqu'à 4 mensualités sans frais supplémentaires." },
      { stat: "Devis", label: "Personnalisé", desc: "Sur demande selon votre profil et programme." },
    ],
  },
};

export const SLUG_BBA = "bba";
export const SLUG_MBA = "mba";
export { COMMON_RYTHMES };
